import { Close, Expand, ExpandMore, FilterList, SearchOutlined, Token } from '@mui/icons-material'
import { Button, Card, AccordionSummary, capitalize, CircularProgress, Divider, IconButton, InputAdornment, TextField } from '@mui/material'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import LinesEllipsis from 'react-lines-ellipsis'
import { Link } from 'react-router-dom'
import PageContainer from '../components/PageContainer';
import Accordion from '../components/common/Accordion';
import { getList, getPublicResources, getToken } from '../redux/api/system'
import { dataTags, partners, searchCategories, searchResults } from '../util'
import DataManagement from '../assets/documents/IDSP Data Management Policy.pdf';
import DataSharing from '../assets/documents/IDSP Data Sharing Agreement.pdf';
import NonDisclose from '../assets/documents/IDSP Non Disclosure Agreement.pdf';
import UserManual from '../assets/documents/IDSP user manual.pdf'

const Publications = ({ user }) => {
    const [ userData, setUserData ] = useState({});
    const [ fetching, setFetching ] = useState(false)
    const { enqueueSnackbar } = useSnackbar();

    const listData = [ 
      {
        title: "User Manual",
        description: "The IDSP portal would warehouse relevant macroeconomic statistical data for Nigeria and provide easy access to those data being shared among partnering agencies; thus, helping to increase data collection efficiency while minimizing inconsistencies in published numbers.",
        size: "300KB",
        link: UserManual
      }, 
      {
        title: "Data Management Policy",
        description: "The purpose of the Data Management Policy is to ensure the secure and responsible sharing of macroeconomic data through the Integrated Data Sharing Portal (IDSP) jointly developed by participating agencies of the Nigerian government. The Policy sets out the requirements for the management of data shared through the portal and outlines the responsibilities of users accessing and using the data.",
        size: "300KB",
        link: DataManagement
      }, 
      {
        title: "Data Sharing Agreement",
        description: "The core purpose of this Agreement is to facilitate the smooth and structured sharing of data among the Participating Agencies, leveraging the IDSP as the designated platform. By doing so, the Agencies seek to enhance their abilities to design, implement, and monitor macroeconomic policies in Nigeria effectively.",
        size: "290KB",
        link: DataSharing
      }, 
      {
        title: "Non-Disclosure Agreement",
        description: "The Participating Agencies entered into an Agreement for the development of an Integrated Data Sharing Portal (IDSP) for the seamless exchange of data between them in order to support macroeconomic policymaking and implementation in Nigeria (hereafter referred to as the Contract).",
        size: "310KB",
        link: NonDisclose

      }, 
    ];
    useEffect(() => {
        setUserData(user)
    }, [user])
    
    return (
        <PageContainer processing={fetching}>
            <section className="inner-banner parallax-section">
                <div className='overlay' style={{ padding: '10rem 0 12rem' }}>
                    <div className="container mt-3 mb-3">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s"></h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Publications</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='p-3 m-3 publication-container'>
                <div className='container'>
                    <h3>Relevant Documents</h3>
                    <div className="faq-container pt-2">
                       {
                          listData.map((res, index) => (
                              <Card className=" publication-section mb-4 d-flex w-100 justify-content-between align-items-end" style={{ borderBottom: '1px solid lightgrey', paddingBottom: '2.5rem' }}>
                                  <div className=" text-area pt-0">

                                    <h5 className='f-22'>{res.title}</h5>
                                   
                                    <p className='mb-05'>
                                        {res.description}
                                    </p>

                                    <div style={{ color: "white" }} className='d-flex pt-2' >
                                      <Button href={res.link} style={{ marginRight: "0.5em" }} download={res?.title} target='_blank' variant="contained">Download</Button>
                                      <Button href={res.link} target='_blank' variant='outlined' style={{ marginLeft: "0.5em" }}>View </Button>
                                    </div>
                                  </div>
                                 
                              </Card>
                          ))
                       }
                    </div>
                </div>
            </section>

        </PageContainer>

    )
}

export default connect(({ user }) => ({ user }))(Publications)